//import React from "react";
import React, { useState, useContext, useEffect } from 'react';
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Datetime from "react-datetime";
import moment from "moment";
import CsvDownloader from 'react-csv-downloader';

// react component for creating dynamic tables
import ReactTable from "react-table";
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";


// @material-ui/icons
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { SessionContext } from "beaktShared/services/session";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Tooltip from "@material-ui/core/Tooltip";
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import { UseGetApiSimple, UsePutApi } from "beaktShared/services/crudeApiService";
import { transformValueFloattoFormated } from "beaktShared/helpers/masks";
import SweetAlert from "react-bootstrap-sweetalert";
import Badge from "beaktShared/components/Badge/Badge.js";
import Select from "react-select";
import { ValidSelect } from "beaktShared/helpers/validselect";

// services
import { MaskDate, validateDate, convertDate, formateDate, getLocale, getStringFormatDate } from "beaktShared/helpers/masks";


import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from 'beaktShared/helpers/extras';
import { UsePostApi } from 'beaktShared/services/crudeApiService';
const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function BoletimOcorrencia() {
    const { t } = useTranslation();
    const classes = useStyles();
    const session = useContext(SessionContext);
    const { register, setValue, errors, setError, clearError, getValues } = useForm({ mode: "onChange" });

    const [isLoadingList, setisLoadingList] = React.useState(false);
    const [loading, setloading] = React.useState(false);

    const [dtini, setdtini] = React.useState(formateDate(moment(new Date()).add(-7, 'days')));
    const [dtfim, setdtfim] = React.useState(formateDate(moment(new Date())));

    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });
    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: message
        });
        setTimeout(function () {
            setNotification({ show: false });
        }, 6000);
    };

    const [alert, setalert] = React.useState();
    const showAlert = (message, tipo) => {
        setalert(<SweetAlert
            error={tipo == 'error' ? true : false}
            warning={tipo == 'warning' ? true : false}
            success={tipo == 'success' ? true : false}
            title="Aviso"
            onConfirm={() => setalert(null)}
        >
            <div dangerouslySetInnerHTML={{ __html: message }} />
        </SweetAlert>);
    };

    const [listBoletins, setlistBoletins] = React.useState([]);
    const [listTable, setlistTable] = React.useState([]);

    const [isLoadingEstabelecimento, setisLoadingEstabelecimento] = React.useState(false);
    const [estabelecimentos, setestabelecimentos] = React.useState([]);
    const [estabelecimento, setestabelecimento] = React.useState(0);

    const LoadEstabelecimentos = () => {
        setisLoadingEstabelecimento(true);
        const endPoint = "estabelecimentos/ativos/byfranquia/" + session.franquiaId;
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'error')
                setisLoadingEstabelecimento(false);
                return false;
            }

            setisLoadingEstabelecimento(false);
            setestabelecimentos([{ descricao: "TODOS", estabelecimentoId: "" }, ...result.data]);
            return true;
        });
    };
    const handleEstabelecimentoChange = event => {
        let value = event
        setestabelecimento(value);
        setValue("estabelecimento", value);
        if (value !== "")
            clearError("estabelecimento");
    };

    const [statusOptions, setStatusOptions] = React.useState([
        { text: "Pendente", value: "Pendente" },
        { text: "Aprovado", value: "Aprovado" },
        { text: "Reprovado", value: "Reprovado" },
    ]);
    const [statusSelected, setStatusSelected] = React.useState("");
    const handleStatusChange = (event) => {
        let value = event
        setStatusSelected(value.value);
        setValue("status", value);
    };


    const [tipoOptions, setTipoOptions] = React.useState([
        { text: "Todos", value: "Todos" },
        { text: "Produto", value: "Produto" },
        { text: "Pacote", value: "Pacote" },
        { text: "Serviço", value: "Serviço" },
    ]);
    const [tipoSelected, setTipoSelected] = React.useState("");
    const handleTipoChange = (event) => {
        let value = event
        setTipoSelected(value.value);
        setValue("tipo", value);
    };

    const handleClickPesquisa = () => {
        let data = getValues();

        if (!validateDate(data.dtini)) {
            setError("dtini", "invaliddate", t('error_message.invalid_date'))
            return false;
        }
        else
            clearError("dtini")

        if (!validateDate(data.dtfim)) {
            setError("dtfim", "invaliddate", t('error_message.invalid_date'))
            return false;
        }
        else
            clearError("dtfim")

        let obj = {
            status: data?.status?.value,
            tipo: data?.tipo?.value,
            estabelecimentoId: estabelecimento == 0 ? null : estabelecimento,
            dataDe: data?.dtini || null,
            dataAte: data?.dtfim,
        }
        loadBoletins(obj);
    }
    const loadBoletins = (obj) => {
        setisLoadingList(true);
        UsePostApi("boletimocorrencia/GetListaBoletimOcorrencias/" + session.franquiaId, obj ? obj : {}).then(result => {
            setisLoadingList(false);
            if (result.status !== 200) {
                showNotification(result.message?.toString() || "Erro ao carregar dados", 'error');
                return false;
            }
            setlistBoletins(result.data);
            var listaatualiza = [];
            for (var i in result.data.boletimPacotes) {
                listaatualiza.push({
                    id: result.data.boletimPacotes[i].id,
                    estabelecimento: result.data.boletimPacotes[i].estabelecimento,
                    tipo: "Pacote",
                    descricao: result.data.boletimPacotes[i].descricao,
                    dataHoraBoletim: formateDate(result.data.boletimPacotes[i].dataHoraBoletim),
                    aprovado: result.data.boletimPacotes[i].aprovado,
                    dataHoraAprovacao: result.data.boletimPacotes[i]?.dataHoraAprovacao ? formateDate(result.data.boletimServicos[i]?.dataHoraAprovacao) : "",
                    usuarioAprovacao: result.data.boletimPacotes[i].usuarioAprovacao,
                    incluirRoyaltie: result.data.boletimPacotes[i].incluirRoyaltie,
                });
            }
            for (var i in result.data.boletimProdutos) {
                listaatualiza.push({
                    id: result.data.boletimProdutos[i].id,
                    estabelecimento: result.data.boletimProdutos[i].estabelecimento,
                    tipo: "Produto",
                    descricao: result.data.boletimProdutos[i].descricao,
                    dataHoraBoletim: formateDate(result.data.boletimProdutos[i].dataHoraBoletim),
                    aprovado: result.data.boletimProdutos[i].aprovado,
                    dataHoraAprovacao: result.data.boletimProdutos[i]?.dataHoraAprovacao ? formateDate(result.data.boletimServicos[i]?.dataHoraAprovacao) : "",
                    usuarioAprovacao: result.data.boletimProdutos[i].usuarioAprovacao,
                    incluirRoyaltie: result.data.boletimProdutos[i].incluirRoyaltie,
                });
            }
            for (var i in result.data.boletimServicos) {
                listaatualiza.push({
                    id: result.data.boletimServicos[i].id,
                    estabelecimento: result.data.boletimServicos[i].estabelecimento,
                    tipo: "Serviço",
                    descricao: result.data.boletimServicos[i].descricao,
                    dataHoraBoletim: formateDate(result.data.boletimServicos[i].dataHoraBoletim),
                    aprovado: result.data.boletimServicos[i].aprovado,
                    dataHoraAprovacao: result.data.boletimServicos[i]?.dataHoraAprovacao ? formateDate(result.data.boletimServicos[i]?.dataHoraAprovacao) : "",
                    usuarioAprovacao: result.data.boletimServicos[i].usuarioAprovacao,
                    incluirRoyaltie: result.data.boletimServicos[i].incluirRoyaltie,
                });
            }
            setlistTable(listaatualiza);
            loadDataCsv(listaatualiza);
        })
    }

    const [dataCSV, setdataCSV] = React.useState([]);
    const columnsCSV = [
        { displayName: "Estabelecimento", id: "estabelecimento" },
        { displayName: "Tipo", id: "tipo" },
        { displayName: "Descrição", id: "descricao" },
        { displayName: "Data Hora Boletim", id: "dataHoraBoletim" },
        { displayName: "Status", id: "aprovado" },
        { displayName: "Data Análise", id: "dataHoraAprovacao" },
        { displayName: "Usuário Análise", id: "usuarioAprovacao" }
    ];
    const loadDataCsv = (data) => {
        let dtCsv = [];

        data.map(item => {
            var obj = {
                estabelecimento: item.estabelecimento,
                tipo: item.tipo,
                descricao: item.descricao,
                dataHoraBoletim: item.dataHoraBoletim,
                aprovado: item.aprovado,
                dataHoraAprovacao: item.dataHoraAprovacao,
                usuarioAprovacao: item.usuarioAprovacao,
            };
            dtCsv.push(obj);
        })

        setdataCSV(dtCsv);
    };
    
    const [showModal, setshowModal] = React.useState(false);
    const [itemEdit, setitemEdit] = React.useState();
    const [detalheModal, setdetalheModal] = React.useState({ valor: 0, valorCusto: 0 });
    const handleEdit = (row) => {
        let item;
        let detalhe;
        if (row.tipo == "Pacote") {
            item = listBoletins.boletimPacotes.filter((f) => f.id == row.id)[0];
            setloading(true);
            UseGetApiSimple("pacotes/" + item.pacote_Id, 0).then(result => {
                setloading(false);
                if (result.status !== 200) {
                    showNotification(result.message, 'error')
                    return false;
                }

                detalhe = {
                    id: item.id,
                    estabelecimento: item.estabelecimento,
                    tipo: "Pacote",
                    descricao: result.data.descricao,
                    valor: result.data.valor,
                    pacote_Id: result.data.pacote_id,
                    valorCusto: 0,
                    tempoExecucao: 0,
                    servicos: result.data.pacoteServicos,
                    produtos: result.data.pacoteProdutos,
                    clausula: item.clausula,
                    registroNovo: item.registroNovo,
                    aprovado: item.aprovado,
                    incluirRoyaltie: item.incluirRoyaltie,
                    jsonDe:
                    {
                        descricao: item.jsonDe.descricao,
                        ativo: item.jsonDe.ativo,
                        clausulaContratoDescricao: item.jsonDe.clausulaContratoDescricao,
                        valor: item.jsonDe.valor,
                        servicos: item.jsonDe.pacoteServicos,
                        produtos: item.jsonDe.pacoteProdutos,
                    },
                    jsonPara:
                    {
                        descricao: item.jsonPara.descricao,
                        ativo: item.jsonPara.ativo,
                        clausulaContratoDescricao: item.jsonPara.clausulaContratoDescricao,
                        valor: item.jsonPara.valor,
                        servicos: item.jsonPara.pacoteServicos,
                        produtos: item.jsonPara.pacoteProdutos,
                    }
                }
                setitemEdit(item);
                setdetalheModal(detalhe);
                setshowModal(true);
            });
        }
        else if (row.tipo == "Produto") {
            item = listBoletins.boletimProdutos.filter((f) => f.id == row.id)[0];
            detalhe = {
                id: item.id,
                estabelecimento: item.estabelecimento,
                tipo: "Produto",
                descricao: item.descricao,
                valor: item.valor,
                valorCusto: item.valorCusto,
                produto_id: item.produto_id,
                tempoExecucao: 0,
                registroNovo: item.registroNovo,
                aprovado: item.aprovado,
                incluirRoyaltie: item.incluirRoyaltie,
                jsonDe:
                {
                    descricao: item.jsonDe.descricao,
                    ativo: item.jsonDe.ativo,
                    produtoGrupoDescricao: item.jsonDe.produtoGrupoDescricao,
                    valor: item.jsonDe.valor,
                    valorCusto: item.jsonDe.valorCusto,
                    controlaEstoque: item.jsonDe.controlaEstoque,
                },
                jsonPara:
                {
                    descricao: item.jsonPara.descricao,
                    ativo: item.jsonPara.ativo,
                    produtoGrupoDescricao: item.jsonPara.produtoGrupoDescricao,
                    valor: item.jsonPara.valor,
                    valorCusto: item.jsonPara.valorCusto,
                    controlaEstoque: item.jsonPara.controlaEstoque,
                }
            }
            setitemEdit(item);
            setdetalheModal(detalhe);
            setshowModal(true);
        }
        else if (row.tipo == "Serviço") {
            item = listBoletins.boletimServicos.filter((f) => f.id == row.id)[0];
            detalhe = {
                id: item.id,
                estabelecimento: item.estabelecimento,
                tipo: "Serviço",
                descricao: item.descricao,
                valor: item.valor,
                valorCusto: 0,
                tempoExecucao: item.tempoExecucao,
                servico_id: item.servico_id,
                clausula: item.clausula,
                registroNovo: item.registroNovo,
                aprovado: item.aprovado,
                incluirRoyaltie: item.incluirRoyaltie,
                jsonDe:
                {
                    descricao: item.jsonDe.descricao,
                    ativo: item.jsonDe.ativo,
                    tempoExecucao: item.jsonDe.tempoExecucao,
                    especialidadeDescricao: item.jsonDe.especialidadeDescricao,
                    clausulaContratoDescricao: item.jsonDe.clausulaContratoDescricao,
                    valor: item.jsonDe.valor,
                },
                jsonPara:
                {
                    descricao: item.jsonPara.descricao,
                    ativo: item.jsonPara.ativo,
                    tempoExecucao: item.jsonPara.tempoExecucao,
                    especialidadeDescricao: item.jsonPara.especialidadeDescricao,
                    clausulaContratoDescricao: item.jsonPara.clausulaContratoDescricao,
                    valor: item.jsonPara.valor,
                }
            }
            setitemEdit(item);
            setdetalheModal(detalhe);
            setshowModal(true);
            clearError("motivoreprova");
        }
    };

    const handleAprovacaoBoletim = (aprovacao) => {
        let data = getValues();
        if (!aprovacao && data.motivoreprova == "") {
            setError("motivoreprova");
            return false;
        }

        itemEdit.aprovado = aprovacao;
        itemEdit.usuarioAprovacao = session.id;
        itemEdit.motivoReprova = (!aprovacao ? data.motivoreprova : "");

        let endpoint = "boletimocorrencia";
        if (detalheModal.tipo == "Pacote")
            endpoint += "/boletimpacote";
        else if (detalheModal.tipo == "Produto")
            endpoint += "/boletimproduto"
        else if (detalheModal.tipo == "Serviço")
            endpoint += "/boletimservico";

        var _itemEdit = {
            ...itemEdit,
            jsonDe: JSON.stringify(itemEdit.jsonDe),
            jsonPara: JSON.stringify(itemEdit.jsonPara)
        }

        setloading(true);
        UsePutApi(endpoint, '', _itemEdit).then(result => {
            setloading(false);
            if (result.status !== 200) {
                showAlert(result.message, "error");
                return false;
            }

            let newlist = listTable.filter((f) => f.id != detalheModal.id);
            setlistTable(newlist);

            setshowModal(false);
            showNotification(t('information_message.operation_performed_successfully'), 'success')
            return true;
        });
    };

    useEffect(() => {
        LoadEstabelecimentos();
        loadBoletins();
    }, []);

    const columnsProp = [{
        Header: t('label.establishment'),
        accessor: "estabelecimento"
    },
    {
        Header: t('sale.type'),
        accessor: "tipo"
    },
    {
        Header: t('label.description'),
        accessor: "descricao"
    },
    {
        Header: t('label.request_date'),
        accessor: "dataHoraBoletim"
    },
    {
        Header: t('label.status'),
        accessor: "aprovado",
    },
    {
        Header: "Data Análise",
        accessor: "dataHoraAprovacao"
    },
    {
        Header: "Usuário Análise",
        accessor: "usuarioAprovacao"
    },
    ]
    const columnsAcao = [
        {
            Header: t('label.actions'),
            Cell: row => (
                <div className="actions-right">
                    <Button
                        justIcon
                        round
                        simple
                        color="success"
                        className="edit"
                        onClick={() => handleEdit(row.original)}
                    >
                        <Tooltip title={t('label.to_edit')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                            <Edit />
                        </Tooltip>
                    </Button>{" "}
                </div>
            ),
            sortable: false,
            filterable: false
        }
    ];
    const columns = [...columnsProp, ...columnsAcao]

    return (
        <div>
            {alert}
            {notification.show &&
                <div><br />
                    <SnackbarContent
                        message={notification.message}
                        color={notification.color}
                        closeNotification={() => setNotification({ show: false })}
                        close
                    />
                </div>}
            <GridContainer>
                {loading &&
                    <div className="carregandoCmp">
                        <div className="box">
                            <label>{t('label.loading')}...</label>
                            <CircularProgress />
                        </div>
                    </div>
                }
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <PlaylistAddCheckIcon />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>{t('information_message.list_of_reports')}</h4>
                        </CardHeader>
                        <CardBody>
                            <GridContainer>
                                <GridItem xs={12} sm={6} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <label className={errors.dtini ? "select__label select__label_error" : "select__label"}>
                                            {t('label.ini_date')}  </label>
                                        <Datetime
                                            locale={getLocale()}
                                            dateFormat={getStringFormatDate()}
                                            timeFormat={false}
                                            name="dtini"
                                            defaultValue={dtini}
                                            value={dtini}
                                            onChange={date => { setdtini(date) }}
                                            inputProps={{ name: "dtini", ref: register({ required: true }), readOnly: 'readonly' }}
                                            className={errors.dtini ? "error" : ""}
                                        />
                                        {errors.dtini && <FormHelperText className={classes.labelRootError}>
                                            <span> {errors.dtini.message} </span>
                                        </FormHelperText>}
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <label className={errors.dtfim ? "select__label select__label_error" : "select__label"}>
                                            {t('label.end_date')}  </label>
                                        <Datetime
                                            locale={getLocale()}
                                            dateFormat={getStringFormatDate()}
                                            timeFormat={false}
                                            name="dtfim"
                                            defaultValue={dtfim}
                                            value={dtfim}
                                            onChange={date => { setdtfim(date) }}
                                            inputProps={{ name: "dtfim", ref: register({ required: true }), readOnly: 'readonly' }}
                                            className={errors.dtfim ? "error" : ""}
                                        />
                                        {errors.dtfim && <FormHelperText className={classes.labelRootError}>
                                            <span> {errors.dtfim.message} </span>
                                        </FormHelperText>}
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={4} md={6}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <label className={errors.estabelecimento ? "select__label select__label_error" : "select__label"}>{t('label.establishment')} </label>
                                        <Select
                                            classNamePrefix="select"
                                            styles={ValidSelect(errors.estabelecimento ? true : false)}
                                            isSearchable={true}
                                            isLoading={isLoadingEstabelecimento}
                                            name="estabelecimento"
                                            placeholder="Selecione..."
                                            options={estabelecimentos}
                                            value={estabelecimentos.filter(({ estabelecimentoId }) => estabelecimentoId === estabelecimento)}
                                            getOptionLabel={({ descricao }) => descricao}
                                            getOptionValue={({ estabelecimentoId }) => estabelecimentoId}
                                            onChange={(value) => handleEstabelecimentoChange(value.estabelecimentoId !== null ? value.estabelecimentoId : "")}
                                            ref={() => register({ name: "estabelecimento" })
                                            }
                                        />
                                        {errors.estabelecimento &&
                                            <FormHelperText>
                                                <span className="obg"> {t('label.select_an_establishment')} </span>
                                            </FormHelperText>}
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <div className="removeScroll">
                                            <label className={errors.status ? "select__label select__label_error" : "select__label"}>{t('label.status')} </label>
                                            <Select
                                                styles={ValidSelect(false)}
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="status"
                                                placeholder={t('label.select') + "..."}
                                                options={statusOptions}
                                                value={statusOptions.filter(({ value }) => value == statusSelected)}
                                                getOptionLabel={({ text }) => text}
                                                getOptionValue={({ value }) => value}
                                                onChange={(value) => handleStatusChange(value)}
                                                ref={() => register({ name: "status" })}
                                            />
                                        </div>
                                        <FormHelperText className={classes.labelRootError}>
                                            {errors.status && <span className="obg"> {t('label.required')} </span>}
                                        </FormHelperText>
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <div className="removeScroll">
                                            <label className={errors.tipo ? "select__label select__label_error" : "select__label"}>Tipo </label>
                                            <Select
                                                styles={ValidSelect(false)}
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="tipo"
                                                placeholder={t('label.select') + "..."}
                                                options={tipoOptions}
                                                value={tipoOptions.filter(({ value }) => value == tipoSelected)}
                                                getOptionLabel={({ text }) => text}
                                                getOptionValue={({ value }) => value}
                                                onChange={(value) => handleTipoChange(value)}
                                                ref={() => register({ name: "tipo" })}
                                            />
                                        </div>
                                        <FormHelperText className={classes.labelRootError}>
                                            {errors.tipo && <span className="obg"> {t('label.required')} </span>}
                                        </FormHelperText>
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={3}>
                                    <Button round color="primary"
                                        onClick={e => { handleClickPesquisa() }}>
                                        {t('label.search')}
                                    </Button>
                                </GridItem>
                            </GridContainer>
                            {dataCSV.length > 0 &&
                                <div>
                                    <div style={{ float: 'right' }}>
                                        <CsvDownloader
                                            filename="Boletins de Ocorrência"
                                            columns={columnsCSV}
                                            datas={dataCSV}
                                            separator={";"}>
                                            <Button round color="default" size="sm" >CSV</Button>
                                        </CsvDownloader>
                                    </div><div style={{ clear: 'both' }}></div>
                                </div>
                            }
                            <ReactTable
                                loading={isLoadingList}
                                data={listTable}
                                columns={columns}
                                filterable
                                defaultFilterMethod={noCaseSensitive}
                                defaultPageSize={10}
                                minRows={5}
                                showPaginationBottom={true}
                                className="-striped -highlight"
                                previousText={t('button.previous')}
                                nextText={t('button.next')}
                                loadingText={t('label.loading') + "..."}
                                noDataText={t('information_message.no_records_found') + "!"}
                                pageText={t('label.page')}
                                ofText={t('label.of')}
                                rowsText={t('label.rows')}
                            />
                        </CardBody>
                    </Card>

                </GridItem>
            </GridContainer>
            <Dialog
                classes={{ root: classes.center + " " + classes.modalRoot, paper: classes.modal + " " + classes.modalLarge }}
                open={showModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setshowModal(false)}
                aria-labelledby="classic-modal-slide-title"
                aria-describedby="classic-modal-slide-description"
            >
                {loading &&
                    <div className="carregandoCmp">
                        <div className="box">
                            <label>{t('label.loading')}...</label>
                            <CircularProgress />
                        </div>
                    </div>
                }
                <DialogTitle
                    id="classic-modal-slide-title"
                    disableTypography
                    className={classes.modalHeader}
                    style={{ background: '#5c4477' }}
                >
                    <Button
                        justIcon
                        className={classes.modalCloseButton}
                        key="close"
                        aria-label="Close"
                        color="transparent"
                        onClick={() => setshowModal(false)}
                    >
                        <Close className={classes.modalClose} />
                    </Button>
                    <h4 className={classes.modalTitle} style={{ color: 'white' }}>{t('label.details_of_the_report')}</h4>
                </DialogTitle>
                <DialogContent id="classic-modal-slide-description"
                    className={classes.modalBody}
                >
                    <br />

                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <GridItem xs={12} sm={12} md={12}>
                                <label style={{ fontSize: '12px', color: '#562682', }}><b>{detalheModal.estabelecimento}</b> </label>
                                <br />
                            </GridItem>

                        </GridItem>
                        {/******************** De ********************/}
                        {!detalheModal.registroNovo && 
                            <GridItem xs={12} sm={12} md={6}>
                                <GridItem xs={12} sm={12} md={12}>
                                    <div className='subTitulo'>
                                        <h6 style={{ fontSize: '13px' }}><b>De:</b></h6>
                                    </div>
                                </GridItem>
                                
                                <GridItem xs={12} sm={12} md={12}>
                                    <label><b>{t('sale.type')}:</b> {detalheModal.tipo}</label>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    <label><b>{t('label.description')}:</b> {detalheModal.jsonDe?.descricao}</label>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    <label><b>{t('label.value')}:</b> {detalheModal.jsonDe?.valor ? detalheModal.jsonDe?.valor : ""}</label>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    <label>
                                        <b>{"Controla Royalties"}: </b> {detalheModal.incluirRoyaltie ? "Sim" : "Não"}
                                    </label>
                                </GridItem>

                                {detalheModal.tipo == "Produto" &&
                                    <div>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <label><b>{t('label.value_cost')}:</b> {detalheModal.jsonDe?.valorCusto}</label>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <label><b>{"Produto Grupo"}:</b> {detalheModal.jsonDe?.produtoGrupoDescricao}</label>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <label>
                                                <b>{"Controla Estoque"}: </b> {detalheModal.jsonDe?.controlaEstoque ? "Sim" : "Não"}
                                            </label>
                                        </GridItem>
                                    </div>
                                }
                                {detalheModal.tipo == "Serviço" &&
                                    <div>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <label><b>{t('information_message.runtime')}:</b> {detalheModal.jsonDe?.tempoExecucao ? detalheModal.jsonDe?.tempoExecucao + "min." : ""} </label>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <label><b>{"Especialidade"}:</b> {detalheModal.jsonDe?.especialidadeDescricao} </label>
                                        </GridItem>
                                    </div>
                                }
                                <GridItem xs={12} sm={12} md={12}>
                                    <label><b>{"Status"}:</b> {detalheModal.jsonDe?.ativo ? "Ativo" : "Inativo"}</label>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    <label><b>{t('label.contract_clause')}:</b> {detalheModal.jsonDe?.ClausulaContratoDescricao == null ? "" : detalheModal.jsonDe?.ClausulaContratoDescricao}</label>
                                </GridItem>

                                {detalheModal.tipo == "Pacote" &&
                                    <div>
                                        <hr></hr>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <label ><b>{t('register.product_list')}:</b></label>
                                        </GridItem>
                                    </div>
                                }

                                {(detalheModal.jsonDe?.produtos != null && detalheModal.jsonDe?.produtos.length > 0) &&
                                    <div>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <div>
                                                {detalheModal.jsonDe?.produtos.map((p) => (
                                                    <span key={p.produtoId} style={{ marginRight: "5px" }}><Badge color="primary">{p.quantidade} - {p.produtoDescricao}</Badge></span>
                                                ))}
                                                <br /><br />
                                            </div>
                                        </GridItem>
                                    </div>

                                }

                                {detalheModal.tipo == "Pacote" &&
                                    <div>
                                        <hr></hr>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <label  ><b>{t('register.list_of_services')}:</b></label>
                                        </GridItem>
                                    </div>
                                }

                                {(detalheModal.jsonDe?.servicos != null && detalheModal.jsonDe?.servicos.length > 0) &&
                                    <div>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <div>
                                                {detalheModal.jsonDe?.servicos.map((p) => (
                                                    <span key={p.servicoId} style={{ marginRight: "5px" }}><Badge color="primary">{p.quantidade} - {p.servicoDescricao}</Badge></span>
                                                ))}
                                                <br /><br />
                                            </div>
                                        </GridItem>
                                    </div>

                                }


                            </GridItem>
                        }
                        {/******************** Para ********************/}
                        <GridItem xs={12} sm={12} md={6}>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className='subTitulo'>
                                    <h6 style={{ fontSize: '13px' }}><b>{!detalheModal.registroNovo ? "Para:" : detalheModal.tipo + " novo"}</b></h6>
                                </div>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <label><b>{t('sale.type')}:</b> {detalheModal.tipo}</label>
                            </GridItem>

                            <GridItem xs={12} sm={12} md={12}>
                                <label><b>{t('label.description')}:</b> {detalheModal.jsonPara?.descricao}</label>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <label><b>{t('label.value')}:</b> {detalheModal.jsonPara?.valor ? detalheModal.jsonPara?.valor : ""}</label>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <label>
                                    <b>{"Controla Royalties"}: </b> {detalheModal.incluirRoyaltie ? "Sim" : "Não"}
                                </label>
                            </GridItem>

                            {detalheModal.tipo == "Produto" &&
                                <div>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <label><b>{t('label.value_cost')}:</b> {detalheModal.jsonPara?.valorCusto}</label>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <label><b>{"Produto Grupo"}:</b> {detalheModal.jsonPara?.produtoGrupoDescricao}</label>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <label>
                                            <b>{"Controla Estoque"}: </b> {detalheModal.jsonPara?.controlaEstoque ? "Sim" : "Não"}
                                        </label>
                                    </GridItem>
                                </div>
                            }
                            {detalheModal.tipo == "Serviço" &&
                                <div>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <label><b>{t('information_message.runtime')}:</b> {detalheModal.jsonPara?.tempoExecucao ? detalheModal.jsonPara?.tempoExecucao + "min." : ""} </label>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <label><b>{"Especialidade"}:</b> {detalheModal.jsonPara?.especialidadeDescricao} </label>
                                    </GridItem>
                                </div>

                            }
                            <GridItem xs={12} sm={12} md={12}>
                                <label><b>{"Status"}:</b> {detalheModal.jsonPara?.ativo ? "Ativo" : "Inativo"}</label>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <label><b>{t('label.contract_clause')}:</b> {detalheModal.jsonPara?.ClausulaContratoDescricao == null ? "" : detalheModal.jsonPara?.ClausulaContratoDescricao}</label>
                            </GridItem>

                            {detalheModal.tipo == "Pacote" &&
                                <div>
                                    <hr></hr>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <label ><b>{t('register.product_list')}:</b></label>
                                    </GridItem>
                                </div>
                            }

                            {(detalheModal.jsonPara?.produtos != null && detalheModal.jsonPara?.produtos.length > 0) &&
                                <div>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <div>
                                            {detalheModal.jsonPara?.produtos.map((p) => (
                                                <span key={p.produtoId} style={{ marginRight: "5px" }}><Badge color="primary">{p.quantidade} - {p.produtoDescricao}</Badge></span>
                                            ))}
                                            <br /><br />
                                        </div>
                                    </GridItem>
                                </div>
                            }

                            {detalheModal.tipo == "Pacote" &&
                                <div>
                                    <hr></hr>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <label  ><b>{t('register.list_of_services')}:</b></label>
                                    </GridItem>
                                </div>
                            }

                            {(detalheModal.jsonPara?.servicos != null && detalheModal.jsonPara?.servicos.length > 0) &&
                                <div>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <div>
                                            {detalheModal.jsonPara?.servicos.map((p) => (
                                                <span key={p.servicoId} style={{ marginRight: "5px" }}><Badge color="primary">{p.quantidade} - {p.servicoDescricao}</Badge></span>
                                            ))}
                                            <br /><br />
                                        </div>
                                    </GridItem>
                                </div>
                            }
                        </GridItem>

                        <GridItem xs={12} sm={12} md={12}>
                            <br />
                            <FormControl fullWidth className={classes.formControl}>
                                <TextField
                                    error={errors.motivoreprova ? true : false}
                                    label={t('information_message.disapproval_reason')}
                                    variant="outlined"
                                    name="motivoreprova"
                                    InputLabelProps={{ shrink: true }}
                                    inputRef={register({
                                        maxLength: {
                                            value: 300
                                        }
                                    })}
                                />
                                <FormHelperText className={classes.labelRootError}>
                                    {errors.motivoreprova && <span className="obg">{t('label.required')}</span>}
                                </FormHelperText>
                            </FormControl>
                        </GridItem>
                    </GridContainer>

                    <br />
                    {detalheModal.aprovado == "Pendente" &&
                        <center className="no-print">
                            <Button color="warning" onClick={() => handleAprovacaoBoletim(false)}>
                                {t('label.disapprove_bulletin')}
                            </Button>
                            <Button color="primary" onClick={() => handleAprovacaoBoletim(true)}>
                                {t('label.approve_bulletin')}
                            </Button>
                        </center>
                    }
                    <br />
                </DialogContent>
            </Dialog>
        </div >
    );
}
